
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ButtonBarItem } from "@/types/controls";
import Icon from "@/components/UI/Icon.vue";
@Component({
  components: { Icon }
})
export default class BigButtonBar extends Vue {
  @Prop()
  value!: string | null;

  @Prop({
    default() {
      return [];
    }
  })
  items!: ButtonBarItem[];

  setValue(string: string) {
    if (!string || this.value === string) {
      this.$emit("input", null);
      return;
    }

    this.$emit("input", string);
  }

  get activeButton() {
    return this.items.map(item => {
      return item.value === this.value;
    });
  }
}
